import { formatOrderDate } from "@ui-b2b/utils/format-date";

export type FormattedDateProps = {
  dateOnly: string; // e.g. "2025-05-15"
  options?: Intl.DateTimeFormatOptions;
  // Business country (e.g. "CH", "DE"). When provided, the date is rendered in
  // the day/month/year order standardized for that country instead of the SSR
  // runtime default locale.
  country?: string;
};

export function FormattedDate({
  dateOnly,
  options = { day: "2-digit", month: "2-digit", year: "numeric" },
  country,
}: FormattedDateProps) {
  // Validate the dateOnly format (YYYY-MM-DD)
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dateOnly)) {
    return <>—</>;
  }

  if (country !== undefined) {
    return (
      <time dateTime={dateOnly}>{formatOrderDate(dateOnly, country)}</time>
    );
  }

  // Build a local-midnight Date
  const [y, m, d] = dateOnly.split("-").map(Number);
  const date = new Date(y, m - 1, d);

  return (
    <time dateTime={dateOnly}>
      {date.toLocaleDateString(undefined, options)}
    </time>
  );
}
